var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5952",
    "data-name": "Path 5952",
    d: "M18.567,2.5H4.433A1.941,1.941,0,0,0,2.5,4.433V18.567A1.941,1.941,0,0,0,4.433,20.5H18.567A1.941,1.941,0,0,0,20.5,18.567V4.433A1.941,1.941,0,0,0,18.567,2.5Zm-10,13.7a.332.332,0,0,1-.322.322H6.536a.332.332,0,0,1-.322-.322V9.188a.332.332,0,0,1,.322-.322H8.241a.332.332,0,0,1,.322.322Zm4.112,0a.332.332,0,0,1-.322.322H10.647a.332.332,0,0,1-.322-.322V6.8a.332.332,0,0,1,.322-.322h1.705a.332.332,0,0,1,.322.322Zm4.112,0a.332.332,0,0,1-.322.322H14.759a.332.332,0,0,1-.322-.322V11.367a.332.332,0,0,1,.322-.322h1.705a.332.332,0,0,1,.322.322Z",
    transform: "translate(-2.5 -2.5)",
    fill: "#49a6f9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyActive);
export default __webpack_public_path__ + "static/media/surveyActive.ae2c275bc5dc4e438c449683face8b4e.svg";
export { ForwardRef as ReactComponent };